/**
 * PropGen module — API client. Points every call at /api/propgen/* on the
 * shared Peak backend. Auth is handled by Peak's cookie session (the
 * superadmin JWT), so we don't need any PropGen-specific auth headers.
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/propgen`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Any 402 (upgrade required) bubbles up as-is — Peak's global interceptor in
// `lib/api.js` handles the modal. We don't need a duplicate interceptor here.

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  if (detail?.msg) return detail.msg;
  if (detail?.message) return detail.message;
  return err?.message || "Something went wrong";
}
